import React from "react";
import { Container, Left, Right, Title, Text } from "./style";
import AgentImg from "../../../assets/imgs/agent.png";
import { Button } from "../Hero/style";

const Agent = () => {
  return (
    <Container>
      <Left src={AgentImg} />
      <Right>
        <Title>Hi, my name's Alex. I'm a New York Real Estate agent.</Title>
        <Text>
          Arcu mattis ante sed est eget nibh velit praesent. Turpis at pharetra
          est quam volutpat sed eget convallis. In morbi turpis tortor nisl vel
          purus. Nisl massa scelerisque quisque quam nulla nec risus duis vitae.
        </Text>
        <Text>
          Morbi ut egestas commodo enim in leo hendrerit euismod. Praesent
          pellentesque congue sit nunc eget. Convallis facilisi ut condimentum
          ac lorem phasellus amet.
        </Text>
        <Button>READ MORE</Button>
      </Right>
    </Container>
  );
};

export default Agent;
